/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import AddIcon from "../../../Assets/images/add.svg";
import EditIcon from "../../../Assets/images/edit.svg";
import DeleteIcon from "./../../../Assets/images/delete.svg";
import ActivatedIcon from "./../../../Assets/images/activated.svg";

// SCSS
import styles from "./index.module.scss";

import { useLocation } from "../../../Context/Cms-Locations/useLocation";
import AddFaqModal from "../../../Components/Modal/Faqs/AddFaq";
import DeleteConfirmation from "./../../../Components/Modal/DeleteConfirmation/DeleteConfirmation";

function LocationFaqs(props) {
  const [showModal, setShowModal] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [modalTitle, setModalTitle] = useState("Add FAQ");
  const [submitStatus, setSubmitStatus] = useState(false);

  // Confirmation modals state
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [statusIndex, setStatusIndex] = useState(null);
  const [currentStatus, setCurrentStatus] = useState(null);

  const { locationState, removeFaq, updateFaqData, setFaqData } = useLocation();

  const handleAddNewFaq = () => {
    setEditIndex(null);
    setModalTitle("Add FAQ");
    setShowModal(true);
  };

  const handleEditFaq = (id) => {
    setEditIndex(id);
    setModalTitle("Edit FAQ");
    setShowModal(true);
  };

  const handleDeleteFaqClick = (id) => {
    setDeleteIndex(id);
    setShowDeleteModal(true);
  };

  const handleDeleteFaqConfirm = () => {
    if (deleteIndex !== null) {
      removeFaq(deleteIndex);
    }
    setShowDeleteModal(false);
    setDeleteIndex(null);
  };

  const handleStatusChangeClick = (id, currentStatus) => {
    setStatusIndex(id);
    setCurrentStatus(currentStatus);
    setShowStatusModal(true);
  };

  const handleStatusChangeConfirm = () => {
    if (statusIndex !== null) {
      const newStatus = currentStatus === 1 ? 0 : 1;
      const updatedFaq = {
        ...locationState.faq.find(faq => faq.id === statusIndex), 
        status: newStatus 
      };
      updateFaqData(updatedFaq, statusIndex);
    }
    setShowStatusModal(false);
    setStatusIndex(null);
    setCurrentStatus(null);
    }

  const handleModalSubmit = (question, answer) => {
    if (!question.trim() || !answer.trim()) {
      setSubmitStatus(true);
      return;
    }

    if (editIndex !== null) {
      // Edit existing FAQ
      const updatedFaq = {
        ...locationState.faq.find(faq => faq.id === editIndex),
        question: question,
        answer: answer,
      };
      updateFaqData(updatedFaq, editIndex);
    } else {
      // Add new FAQ
      const newFaq = {
        id: 0,
        location_id: 0,
        question: question,
        answer: answer,
        status: 1,
      };
      const updatedFaqs = [...locationState.faq, newFaq];
      setFaqData(updatedFaqs);
    }

    setShowModal(false);
    setSubmitStatus(false);
    setEditIndex(null);
  };

  const handleModalCancel = () => {
    setShowModal(false);
    setSubmitStatus(false);
    setEditIndex(null);
  };

  // Get current FAQ data for modal
  const currentFaq = editIndex !== null ? locationState.faq.find(faq => faq.id === editIndex) : null;

  return (
    <div className={`${styles.productsWrapper}`} id="location-faqs">
      <div className="">
        <div className="">
          <div className={styles.title}>FAQs</div>
          <span
            className={`link cursor-pointer ml-2 ${styles.searchIconWrapper}`}
            onClick={(e) => {
              e.preventDefault();
              handleAddNewFaq();
            }}
          >
            <img className={styles.searchIcon} src={AddIcon} alt="" />
          </span>
        </div>
      </div>

      <div className="table-responsive mt-2 mb-4">
        <table className="table">
          <thead>
            <tr>
              <th className="text-left">Question</th>
              <th className="text-left">Status</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody style={{ verticalAlign: "middle" }}>
            {locationState.faq?.length === 0 || !locationState.faq ? (
              <tr>
                <td className={``}>No FAQ</td>
                <td className={``}>-</td>
                <td className={`text-center`}>-</td>
              </tr>
            ) : (
              locationState.faq &&
              locationState.faq.length > 0 &&
              locationState.faq
                .filter((faq) => faq.status !== 2)
                .map((faq, index) => {
                  return (
                    <tr className={`${styles.tableStyle}`} key={index}>
                      <td className={``} style={{ minWidth: "300px" }}>
                        <div className="text-truncate" title={faq.question}>
                          {faq.question.length > 75
                            ? faq.question.substring(0, 75) + "..."
                            : faq.question}
                        </div>
                      </td>
                      <td className={``} style={{ minWidth: "120px" }}>
                        <div className={styles.faqStatus}>
                          {faq.status === 1 ? (
                            <div
                              className={styles.Active}
                              style={{ padding: "10px" }}
                            >
                              Active
                            </div>
                          ) : (
                            <div
                              className={styles.Inactive}
                              style={{ padding: "10px" }}
                            >
                              Inactive
                            </div>
                          )}
                        </div>
                      </td>
                      <td
                        className={`text-center`}
                        style={{ minWidth: "120px" }}
                      >
                        <div className={`d-flex justify-content-center`}>
                          <img
                            className={`cursor-pointer ml-2`}
                            src={EditIcon}
                            alt="Edit"
                            onClick={(e) => {
                              e.preventDefault();
                              handleEditFaq(faq.id);
                            }}
                          />
                          <img
                            className={`cursor-pointer ml-3`}
                            src={ActivatedIcon}
                            alt="Active"
                            onClick={(e) => {
                              e.preventDefault();
                              handleStatusChangeClick(faq.id, faq.status);
                            }}
                          />
                          <img
                            className={`cursor-pointer ml-3`}
                            src={DeleteIcon}
                            alt="Delete"
                            onClick={(e) => {
                              e.preventDefault();
                              handleDeleteFaqClick(faq.id);
                            }}
                            style={{
                              color: "#F37C7C",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })
            )}
          </tbody>
        </table>
      </div>

      {/* Add/Edit FAQ Modal */}
      <AddFaqModal
        showModal={showModal}
        pageTitle={modalTitle}
        submitStatus={submitStatus}
        defaultValue={currentFaq?.question || ""}
        defaultValueSlug={currentFaq?.answer || ""}
        handleSubmitClick={handleModalSubmit}
        handleCancelClick={handleModalCancel}
      />

      {/* Delete Confirmation Modal */}
      <DeleteConfirmation
        showModal={showDeleteModal}
        title="Delete FAQ"
        message="Are you sure want to delete this FAQ?"
        handleCancelClick={(event) => {
          event.preventDefault();
          setShowDeleteModal(false);
          setDeleteIndex(null);
        }}
        handleSubmitClick={handleDeleteFaqConfirm}
      />

      {/* Delete Confirmation Modal */}
      <DeleteConfirmation
        showModal={showStatusModal}
        title={`FAQ ${currentStatus === 1 ? "Inactivate" : "Activate"}`}
        message={`Are you sure want to ${
          currentStatus === 1 ? "inactivate" : "activate"
        } this FAQ?`}
        handleCancelClick={(event) => {
          event.preventDefault();
          setShowStatusModal(false);
          setStatusIndex(null);
          setCurrentStatus(null);
        }}
        btn1_title={currentStatus === 1 ? "Inactivate" : "Activate"}
        handleSubmitClick={handleStatusChangeConfirm}
      />
    </div>
  );
}

export default LocationFaqs;
